
import { createSlice } from '@reduxjs/toolkit'
import { meld } from '../../lib/logboek';
const initialState = {
  adult: 1,
  child: 0,
  kid: 0,
  baby: 0,
  toddler: 0,
  EventorStdTicketData:[],
  guestCounts:{},
  StdDates:[],
  EventDates:[],
  isGreaterThan10: {
    adult: false,
    child: false,
    kid: false,
    baby: false,
    toddler: false,
  },
  activityDataLoading:false,
  dateLoading:false,
  isBookNowOpen: false,
  totalCount:1,
  selectedDate:'',
  reservType:{},
  time:'',
  reservGroup:{},
  reservationTypeDatas:[],
  freeTablesData:[],
  reservationGroupData:[],
  GuestDetailsData:[],
  extraProductData:[],
  selectedExtraProduct:[],
  transactionDetails:{},
  guestFields:[],
  combinationWidgetData:[],
  selectedCombination:[],
  addFields:[],
  reservationLang:'',
  ReservationDetail:null,
  OpeningHoursWidget:[],
  languageWords:{},
  isBackToHoreca:false,
  languageId:null,
  isOpenWidget:false,
  defaultLanguage: "",
  extraFieldsData:[],
  ActivityData:[],
  blockedDates: [],
  quantities:{},
  activityDuration:{},
  combinationList:[],
  EventOrStdTicketTypesData:[],
  SelectedEventOrStdResType:{},
  TotalPrice:0,
  disCountPrice:0,
  TotalPriceInclusiveVATs:0,
  TotalVAT:0,
  combinationUpsaleProductsQTY:{},
  combinationUpsaleData:[],
  selectedCombinationUpsale:[],
  // De bestelling uit de kaartverkoopwidget (opdracht 2E, 11-10-2026): de regels voor de server (Kaarten) en voor de samenvatting.
  kaartverkoop: null,


}
export const addTicketingSlice = createSlice({
  name: 'Ticketing',
  initialState,
  reducers: {
    updateEventsOrStandardTickets:(state,action)=>{
        state.EventorStdTicketData = action.payload;
    },
    updateStdDates:(state,action)=>{
      state.StdDates = action.payload;
    },
    updateEventDates:(state,action)=>{
      state.EventDates = action.payload;
    },
    updateEventOrStdTicketTypesData:(state,action)=>{
      state.EventOrStdTicketTypesData = action.payload;
    },

    // setGuestCount: (state, action) => {
    //   const { guestType, count } = action.payload;
    //   if (state[guestType] !== undefined) {
    //     state[guestType] = count;
    //   }
    // },
    // setGuestCount: (state, action) => {

    //   const { idreservationtype, guestType, count } = action.payload;
    //   if (!state.guestCounts[idreservationtype]) {
    //     state.guestCounts[idreservationtype] = {
    //       adult: 1,
    //       child: 0,
    //       kid: 0,
    //       baby: 0,
    //       toddler: 0,
    //     };
    //   }
    //   else {
    //     // Maintain the previous state if count is undefined/null
        
    //     state.guestCounts[idreservationtype] = {
    //       ...state.guestCounts[idreservationtype], // Keep previous values
    //       [guestType]: count ?? state.guestCounts[idreservationtype][guestType], // Maintain previous value if count is undefined
    //     };
    //   }
    
     
    // },
    setGuestCount: (state, action) => {
      const { idreservationtype, guestType, count } = action.payload;
    
      if (!state.guestCounts[idreservationtype]) {
        state.guestCounts[idreservationtype] = {
          adult: 1,
          child: 0,
          kid: 0,
          baby: 0,
          toddler: 0,
        };
      } else {
        // Keep only the current idreservationtype in the state
        state.guestCounts = {
          [idreservationtype]: {
            ...state.guestCounts[idreservationtype], // Preserve existing values of the current reservation
            [guestType]: count ?? state.guestCounts[idreservationtype][guestType], // Maintain previous value if count is undefined
          }
        };
      }
    },
    

    
    checkGuestLimit: (state, action) => {
      const { guestType, isGreaterThan10 } = action.payload;
      if (state.isGreaterThan10[guestType] !== undefined) {
        state.isGreaterThan10[guestType] = isGreaterThan10;
      }
    },
    toggleBookNowOpen: (state) => {
      state.isBookNowOpen =!state.isBookNowOpen;
    },
    // updateTotalCount: (state, action) => {
    //   state.totalCount = action.payload;
    // },
    updateTotalCount: (state) => {
      state.totalCount = Object.values(state.guestCounts).reduce(
        (sum, counts) =>
          sum + Object.values(counts).reduce((subSum, num) => subSum + num, 0),
        0
      ) || 1;
    },
    updateSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    updateReservationType: (state, action) => {
      state.reservType = action.payload;
    },
    updateActivityDuration: (state, action) => {
      state.activityDuration = action.payload;
    },
    updateTime: (state, action) => {
      state.time = action.payload;
    },
    updateReservationGroup: (state, action) => {
      state.reservGroup = action.payload;
    },
    setReservationTypeDatas: (state, action) => {
      state.reservationTypeDatas = action.payload;
    },
    setReservationGroupDatas: (state, action) => {
      state.reservationGroupData = action.payload;
    },
    setFreeTablesData: (state, action) => {
      state.freeTablesData = action.payload;
    },
    setGuestDetailsData: (state, action) => {
      state.GuestDetailsData = action.payload;
    },
    setExtraProductData: (state, action) => {
      state.extraProductData = action.payload;
    },
    setSelectedExtraProduct: (state, action) => {
      state.selectedExtraProduct = action.payload;
    },
    setTransactionDetails: (state, action) => {
      state.transactionDetails = action.payload;
    },
    setGuestFields: (state, action) => {
      state.guestFields = action.payload;
    },
    setCombinationWidgetData: (state, action) => {
      state.combinationWidgetData = action.payload;
    },
    setSelectedCombination: (state, action) => {
      meld("payload",action.payload)
      state.selectedCombination = action.payload;
    },
    setAddFields: (state, action) => {
      state.addFields = action.payload;
    },
    setReservationLang: (state, action) => {
      state.reservationLang = action.payload;
    },
    setReservationDetail:(state, action) => {
      state.ReservationDetail = action.payload;
    },
    SetUpateOpeningHours: (state, action) => {
      state.OpeningHoursWidget = action.payload
    },
    setLanguageWords: (state, action) => {
      state.languageWords = action.payload
    },
    setDateLoading:(state, action) => {
      state.dateLoading = action.payload
    },
    setIsBackToHoreca:(state, action) => {
      state.isBackToHoreca = action.payload
    },
    setLanguageID:(state, action) => {
      state.languageId = action.payload
    },
    setIsOpenWidget:(state, action) => {
      state.isOpenWidget = action.payload
    },
    updateDefaultLanguage: (state, action) => {
      state.defaultLanguage = action.payload;
    },
    setExtraFieldsData: (state, action) => {
      state.extraFieldsData = action.payload;
    },
    // Add more reducers as needed for other parts of your application  // For example, to handle other state changes related to guests, reservations, etc.  // Remember to follow the same pattern as the setGuestCount and checkGuestLimit reducers.  // For example:
    setActivityDataLoading:(state, action) => {
        state.activityDataLoading = action.payload;
    },
    setActivityData:(state, action) => {
        state.ActivityData = action.payload;
    },
    updateBlockedDates: (state, action) => {
        state.blockedDates = action.payload;
      },
    setQuantities:(state, action) => {
      state.quantities = action.payload;
    },
    setCombinationList:(state, action) => {
      state.combinationList = action.payload;
    },
    setEventOrStdTicketTypesData:(state, action) => {
      state.EventOrStdTicketTypesData = action.payload;
    },
    setSelectedEventOrStdResType:(state, action) => {
      state.SelectedEventOrStdResType = action.payload;
    },
    updateTotalPrice:(state, action) => {
      state.TotalPrice = action.payload;
    },
    updateDisCountPrice:(state, action) => {
      state.disCountPrice = action.payload;
    },
    setTotalPriceInclusiveVAT:(state, action) => {
      state.TotalPriceInclusiveVATs = action.payload;
    },
    setTotalVAT:(state, action)=>{
      state.TotalVAT = action.payload;
    },
    setCombinationUpsaleProductsQTY:(state,action)=>{
      state.combinationUpsaleProductsQTY=action.payload
    },
    setCombinationUpsaleData:(state,action)=>{
      state.combinationUpsaleData=action.payload
    },
    setSelectedCombinationExtraProduct: (state, action) => {
      state.selectedCombinationUpsale = action.payload;
    },
    // Kaartverkoop (opdracht 2E): "Verder" zet de bestelling en de velden die de stappen erna lezen (eerste kaartsoort, dag, aantal,
    // ticketbedrag) in een keer. Zonder payload: leeg.
    zetKaartverkoop: (state, action) => {
      const k = action.payload;
      if (!k) {
        state.kaartverkoop = null;
        return;
      }
      state.kaartverkoop = { kaarten: k.kaarten, regels: k.regels, totaal: k.totaal, scherm: k.scherm };
      state.reservType = k.reservType;
      state.selectedDate = k.selectedDate;
      state.SelectedEventOrStdResType = k.soort;
      state.guestCounts = k.guestCounts;
      state.totalCount = k.totalCount;
      state.TotalPrice = k.totaal;
      state.disCountPrice = k.totaal;
      state.selectedExtraProduct = [];
      state.quantities = {};
      state.selectedCombination = [];
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setCombinationUpsaleProductsQTY,
  setCombinationUpsaleData,
  setSelectedCombinationExtraProduct,
  setGuestCount,
  checkGuestLimit,
  toggleBookNowOpen,
  updateTotalCount,
  updateSelectedDate,
  updateReservationType,
  updateTime,
  updateReservationGroup,
  setReservationTypeDatas,
  setFreeTablesData,
  setReservationGroupDatas,
  setGuestDetailsData,
  setExtraProductData,
  setSelectedExtraProduct,
  setTransactionDetails,
  setGuestFields,
  setCombinationWidgetData,
  setSelectedCombination,
  setAddFields,
  setReservationLang,
  setReservationDetail,
  SetUpateOpeningHours,
  setQuantities,
  setLanguageWords,
  setDateLoading,
  setIsBackToHoreca,
  setLanguageID,
  setIsOpenWidget,
  updateDefaultLanguage,
  setExtraFieldsData,
  // Add more action creators as needed for other parts of your application  // For example, to handle other actions related to guests, reservations, etc.  // Remember to follow the same pattern as the setGuestCount and checkGuestLimit action creators.  // For example:
  setActivityDataLoading,
  setActivityData,
  updateBlockedDates,
  updateActivityDuration,
  setCombinationList,
  updateEventsOrStandardTickets,
  updateStdDates,
  updateEventDates,
  updateEventOrStdTicketTypesData,
  setSelectedEventOrStdResType,
  updateTotalPrice,
  updateDisCountPrice,
  setTotalVAT,
  setTotalPriceInclusiveVAT,
  zetKaartverkoop

} = addTicketingSlice.actions

export default addTicketingSlice.reducer;